<template>
  <div class="passenger-port">
    <div class="formTitle">下单入口配置</div>
    <el-table :data="tableData" border>
      <el-table-column prop="city" label="城市" />
      <el-table-column prop="entrance1" label="入口1" />
      <el-table-column prop="entrance2" label="入口2" />
      <el-table-column prop="entrance3" label="入口3" />
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-popconfirm title="确定删除吗？" @confirm="handleDelete(scope.row)" v-if="scope.row.city !== '通用'">
            <el-button slot="reference" type="text" style="color: #F56C6C;margin-left: 10px;">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="add-city">
      <el-button size="medium" @click="handleAdd">+ 添加城市</el-button>
    </div>

    <ConfigDialog :visible.sync="visible" :type="editType" :rowData="rowData" @submit="handleSubmit" @close="handleClose" />
  </div>
</template>

<script>
import ConfigDialog from './ConfigDialog.vue'
import { getCity } from "@/assets/js/city";
export default {
  components: {
    ConfigDialog
  },
  data() {
    return {
      visible: false,
      tableData: [],
      editType: 'add',
      rowData: {}
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    async getTableData() {
      const { code, data } = await this.$axios.get('/api/v1/manage/appletConfig/list')
      if (code === 1) {
        let newData = data.map(item => {
          return {
            ...item,
            homeConfig: JSON.parse(item.homeConfig)
          }
        })
        newData.forEach(item => {
          item.homeConfig.forEach((citem, index) => {
            item[`entrance${index + 1}`] = citem.displayName
          })
        })
        this.tableData = newData
      }
    },
    handleAdd() {
      this.visible = true
      this.editType = 'add'
      this.rowData = {}
    },
    handleEdit(row) {
      this.visible = true
      this.editType = 'edit'
      this.rowData = { ...row }
      console.log('this.rowData', this.rowData)
    },
    async handleDelete(row) {
      const { code } = await this.$axios.delete(`/api/v1/manage/appletConfig/${row.id}`)
      if (code === 1) {
        this.$message.success('删除成功')
        this.getTableData()
      }
    },
    handleClose() {
      this.visible = false
    },
    async handleSubmit(city, data, id) {
      console.log(city, data, id)
      const { code } = await this.$axios.post('/api/v1/manage/appletConfig', {
        city: city ? getCity(city).city : '通用',
        cityCode: city ? city : '',
        homeConfig: JSON.stringify(data),
        id: id
      })
      if (code === 1) {
        this.getTableData()
        this.$message.success('操作成功')
        this.handleClose()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.passenger-port {
  width: 800px;

  .add-city {
    width: 100%;
    margin-top: 20px;

    .el-button {
      width: 100%;
    }
  }
}
</style>
